$( window.onload = function() {
    $.widget( "custom.iconselectmenu", $.ui.selectmenu, {
      _renderItem: function( ul, item ) {
        var li = $( "<li>" ),
          wrapper = $( "<div>", { text: item.label } );
 
        if ( item.disabled ) {
          li.addClass( "ui-state-disabled" );
        }
 
        $( "<span>", {
          style: item.element.attr( "data-style" ),
          "class": "ui-icon " + item.element.attr( "data-class" )
        })
          .appendTo( wrapper );
 
        return li.append( wrapper ).appendTo( ul );
      }
    });
    $( "#materialList" ).iconselectmenu({ change: function( event, ui ) { 
        document.getElementById("preview").innerHTML = '';
        document.getElementById("form-input-productsSelected").innerHTML = '';
        var canvasColours = document.getElementById("canvasColours");
        var canvasColoursList = document.getElementById("canvasColoursList");
        var canvasColoursListBtn = document.getElementById("canvasColoursList-button");
        var elementsColours = document.getElementById("elementsColours");
        var elementsColoursList = document.getElementById("elementsColoursList");
        var elementsColoursListBtn = document.getElementById("elementsColoursList-button");
        var disclaimer = document.getElementById("disclaimer");
        if (this.value == 'Canvas')
        {
            $(canvasColoursList).prop("disabled", false);
            $(canvasColoursListBtn).addClass("active").prop("disabled", false).removeClass('iconselectmenu-disabled ui-state-disabled').attr('aria-disabled', false);
            $(elementsColoursList).prop('selectedIndex',0).iconselectmenu().iconselectmenu("refresh");
            $(elementsColoursListBtn).removeClass("active");
            canvasColours.style.display = "flex";
            elementsColours.style.display = "none";
        } 
        else if (this.value == '4Elements')
        {
            $(elementsColoursList).prop("disabled", false);
            $(elementsColoursListBtn).addClass("active").prop("disabled", false).removeClass('iconselectmenu-disabled ui-state-disabled').attr('aria-disabled', false);
            $(canvasColoursList).prop('selectedIndex',0).iconselectmenu().iconselectmenu("refresh");
            $(canvasColoursListBtn).removeClass("active");
            $(disclaimer).addClass("hidden");
            canvasColours.style.display = "none";
            elementsColours.style.display = "flex";        
        } 
        else {
            $(canvasColoursList).prop('selectedIndex',0).iconselectmenu().iconselectmenu("refresh");
            $(canvasColoursListBtn).removeClass("active");
            $(elementsColoursList).prop('selectedIndex',0).iconselectmenu().iconselectmenu("refresh");
            $(elementsColoursListBtn).removeClass("active");
        }
    }});
    $( "#canvasColoursList" ).iconselectmenu({ change: function( event, ui ) { 
        var formWrap = document.getElementById("formWrap");
        var contactDetails = document.getElementById("contactDetails");
        var val = $(this).val();
        $(contactDetails).addClass("active");
        formWrap.style.display = "block";
        $(formWrap).show();
        // Pass the checkbox name to the function
        function getCheckedBoxes(product) {
          var checkboxes = document.getElementsByName(product);
          var checkboxesChecked = [];
          // loop over them all
          for (var i=0; i<checkboxes.length; i++) {
             // And stick the checked ones onto an array...
             if (checkboxes[i].checked) {
                checkboxesChecked.push(checkboxes[i]);
             }
          }
          // Return the array if it is non-empty, or null
          return checkboxesChecked.length > 0 ? checkboxesChecked : null;
        }

        var products = [];
        var productsForm = [];
            var checkedBoxes = getCheckedBoxes("product");
        for (var i=0; i<checkedBoxes.length; i++) {
            var product = checkedBoxes[i].value;
            var basePart = checkedBoxes[i].getAttribute('data-basepart');
            var material = 'Canvas';        
            var colour = this.value;
            var isNonStandard = $(this).find(':selected').attr('data-nonstandard');
            var isCamo = $(this).find(':selected').attr('data-camo');
            if (isCamo == 1){
                var price = checkedBoxes[i].getAttribute('data-canvascamoretailprice');
            $(disclaimer).removeClass("hidden");
            } else if (isNonStandard == 1) {
                var price = checkedBoxes[i].getAttribute('data-canvasnonstandardretailprice');
            $(disclaimer).removeClass("hidden");
            } else {
                var price = checkedBoxes[i].getAttribute('data-canvasretailprice');
                $(disclaimer).addClass("hidden");
            }
            var code = $(this).find(':selected').attr('data-code');
            if(typeof code === "undefined"){
                var code = null;
            }
            
            products.push( `
            <div class="bg-white py-2 px-4 rounded-lg mt-4 flex flex-wrap md:justify-end">
                <span class="inline-block py-2 pr-6 pl-2 text-lg self-center flex-grow">` + product + `<small id="code" class="inline-block p-2 self-center flex-grow">` + basePart + `</small></span>
                <div class="flex flex-shrink"><small class="inline-block p-2 self-center flex-shrink">` + material + `</small>
                <small class="inline-block p-2 self-center flex-shrink whitespace-nowrap">` + colour + `</small>
                </div>
            </div>
            `);
            productsForm.push( `\n
                • ` + product + `\n Base Part: ` + basePart + code + `\n  Material: ` + material + `\n   Colour: ` + colour + `\nPrice: ` +  price + `\n-------`);

        }
        document.getElementById("preview").innerHTML = products.join("");
        document.getElementById("form-input-productsSelected").value = productsForm.join('');
    }});
    $( "#elementsColoursList" ).iconselectmenu({ change: function( event, ui ) { 
        var formWrap = document.getElementById("formWrap");
        var contactDetails = document.getElementById("contactDetails");
        var val = $(this).val();
        $(contactDetails).addClass("active");
        formWrap.style.display = "block";
        $(formWrap).show();
        // Pass the checkbox name to the function
        function getCheckedBoxes(product) {
          var checkboxes = document.getElementsByName(product);
          var checkboxesChecked = [];
          // loop over them all
          for (var i=0; i<checkboxes.length; i++) {
             // And stick the checked ones onto an array...
             if (checkboxes[i].checked) {
                checkboxesChecked.push(checkboxes[i]);
             }
          }
          // Return the array if it is non-empty, or null
          return checkboxesChecked.length > 0 ? checkboxesChecked : null;
        }

        var products = [];
        var productsForm = [];
        var checkedBoxes = getCheckedBoxes("product");
        for (var i=0; i<checkedBoxes.length; i++) {
            var product = checkedBoxes[i].value;
            var basePart = checkedBoxes[i].getAttribute('data-basepart');
            var material = '4Elements';        
            var colour = this.value;
            var price = checkedBoxes[i].getAttribute('data-elementsretailprice');
            var code = $(this).find(':selected').attr('data-code');
            if(typeof code === "undefined"){
                var code = null;
            }

            products.push( `
            <div class="bg-white py-2 px-4 rounded-lg mt-4 flex flex-wrap md:justify-end">
                <span class="inline-block py-2 pr-6 pl-2 text-lg self-center flex-grow">` + product + `<small id="code" class="inline-block p-2 self-center flex-grow">` + basePart + `</small></span>
                <div class="flex flex-shrink"><small class="inline-block p-2 self-center flex-shrink">` + material + `</small>
                <small class="inline-block p-2 self-center flex-shrink whitespace-nowrap">` + colour + `</small>
                </div>
            </div>
            `);
            productsForm.push( `\n
                • ` + product + `\n Base Part: ` + basePart + code + `\n  Material: ` + material + `\n   Colour: ` + colour + `\nPrice: ` +  price + `\n-------`);

        }
        document.getElementById("preview").innerHTML = products.join("");
        document.getElementById("form-input-productsSelected").value = productsForm.join('');
    }});
});


$('input[name="product"]').click(function () {
var personaliseProduct = document.getElementById("personaliseProduct");
var materialList = document.getElementById("materialList");
var materialListBtn = document.getElementById("materialList-button");
var multipleProducts = document.getElementById("multipleProducts");
var contactDetails = document.getElementById("contactDetails");
    if ($("#productSelect input:checkbox:checked").length > 0)
    {
        personaliseProduct.classList.add("active");
        $(materialList).prop("disabled", false);
        $(materialListBtn).addClass("active").prop("disabled", false).removeClass('iconselectmenu-disabled ui-state-disabled').attr('aria-disabled', false);

        var canvasColoursList = document.getElementById("canvasColoursList");
        var elementsColoursList = document.getElementById("elementsColoursList");

        if ( canvasColoursList.value != '' ) 
        {
        function getCheckedBoxes(product) {
          var checkboxes = document.getElementsByName(product);
          var checkboxesChecked = [];
          // loop over them all
          for (var i=0; i<checkboxes.length; i++) {
             // And stick the checked ones onto an array...
             if (checkboxes[i].checked) {
                checkboxesChecked.push(checkboxes[i]);
             }
          }
          // Return the array if it is non-empty, or null
          return checkboxesChecked.length > 0 ? checkboxesChecked : null;
        }

        var products = [];
        var productsForm = [];
        var checkedBoxes = getCheckedBoxes("product");
        for (var i=0; i<checkedBoxes.length; i++) {
            var product = checkedBoxes[i].value;
            var basePart = checkedBoxes[i].getAttribute('data-basepart');
            var material = 'Canvas';        
            var colour = canvasColoursList.value;
            var isNonStandard = $(this).find(':selected').attr('data-nonstandard');
            var isCamo = $(this).find(':selected').attr('data-camo');
            if (isCamo == 1){
                var price = checkedBoxes[i].getAttribute('data-canvascamoretailprice');
            } else if (isNonStandard == 1) {
                var price = checkedBoxes[i].getAttribute('data-canvasnonstandardretailprice');
            } else {
                var price = checkedBoxes[i].getAttribute('data-canvasretailprice');
            }
            var code = $(this).find(':selected').attr('data-code');
            if(typeof code === "undefined"){
                var code = null;
            }

            products.push( `
            <div class="bg-white py-2 px-4 rounded-lg mt-4 flex flex-wrap md:justify-end">
                <span class="inline-block py-2 pr-6 pl-2 text-lg self-center flex-grow">` + product + `<small id="code" class="inline-block p-2 self-center flex-grow">` + basePart + `</small></span>
                <div class="flex flex-shrink"><small class="inline-block p-2 self-center flex-shrink">` + material + `</small>
                <small class="inline-block p-2 self-center flex-shrink whitespace-nowrap">` + colour + `</small>
                </div>
            </div>
            `);
            productsForm.push( `\n
                • ` + product + `\n Base Part: ` + basePart + code + `\n  Material: ` + material + `\n   Colour: ` + colour + `\nPrice: ` +  price + `\n-------`);

        }
        document.getElementById("preview").innerHTML = products.join("");
        document.getElementById("form-input-productsSelected").value = productsForm.join('');
        }
        else if ( elementsColoursList.value != '' ) 
        {
        function getCheckedBoxes(product) {
          var checkboxes = document.getElementsByName(product);
          var checkboxesChecked = [];
          // loop over them all
          for (var i=0; i<checkboxes.length; i++) {
             // And stick the checked ones onto an array...
             if (checkboxes[i].checked) {
                checkboxesChecked.push(checkboxes[i]);
             }
          }
          // Return the array if it is non-empty, or null
          return checkboxesChecked.length > 0 ? checkboxesChecked : null;
        }

        var products = [];
        var productsForm = [];
        var checkedBoxes = getCheckedBoxes("product");
        for (var i=0; i<checkedBoxes.length; i++) {
            var product = checkedBoxes[i].value;
            var basePart = checkedBoxes[i].getAttribute('data-basepart');
            var material = '4Elements';        
            var colour = elementsColoursList.value;
            var price = checkedBoxes[i].getAttribute('data-elementsretailprice');
            var code = $(this).find(':selected').attr('data-code');
            if(typeof code === "undefined"){
                var code = null;
            }

            products.push( `
            <div class="bg-white py-2 px-4 rounded-lg mt-4 flex flex-wrap md:justify-end">
                <span class="inline-block py-2 pr-6 pl-2 text-lg self-center flex-grow">` + product + `<small id="code" class="inline-block p-2 self-center flex-grow">` + basePart + `</small></span>
                <div class="flex flex-shrink"><small class="inline-block p-2 self-center flex-shrink">` + material + `</small>
                <small class="inline-block p-2 self-center flex-shrink whitespace-nowrap">` + colour + `</small>
                </div>
            </div>
            `);
            productsForm.push( `\n
                • ` + product + `\n Base Part: ` + basePart + code + `\n  Material: ` + material + `\n   Colour: ` + colour + `\nPrice: ` +  price + `\n-------`);

        }
        document.getElementById("preview").innerHTML = products.join("");
        document.getElementById("form-input-productsSelected").value = productsForm.join('');
        }

        if ($("#productSelect input:checkbox:checked").length > 1) 
        {
            multipleProducts.style.display = "inline";
        } else {
            multipleProducts.style.display = "none";
        }
    } else
    {
        document.getElementById("preview").innerHTML = '';
        document.getElementById("form-input-productsSelected").innerHTML = '';
        personaliseProduct.classList.remove("active");
        $(contactDetails).removeClass("active");
        $(materialList).prop("disabled", true).val('');
        $(materialListBtn).removeClass("active").prop("disabled", true).addClass('iconselectmenu-disabled ui-state-disabled').attr('aria-disabled', true);
        $(formWrap).hide();
    }
});

